import { MessageService } from "./services/message.service";
import { PipeModule } from "./pipe/pipe.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { CusHttp } from "./services/CusHttp";
import { LoginUserService } from './services/login-user.service';
import { AdService } from './services/ad.service';
import { NotificationService } from './services/notification.service';
@NgModule({
  imports: [CommonModule, HttpClientModule, PipeModule],
  exports: [PipeModule],
  providers: [CusHttp, MessageService, LoginUserService, AdService, NotificationService],
})
export class CoreModule { }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/core/core.module.ts